import _ from "lodash";
import { Button } from "../../app/core/ui";
import { newLoadingMask } from "../components/mask";
import { alert } from "../core/alert";
import { clone, searchDebounceWait } from "../core/core";
import * as divisionRegion from "../core/division.region";
import { ll } from "../core/ll";
import { settings } from "../core/settings";
import { buildODataKendoParams } from "../data/buildODataKendoParams";
import { codes } from "../data/codes";
import { schemas } from "../data/schemas";
import * as charts from "./charts";

export function initialize(args) {
    var options = args.options || {},
        _id = args._id,
        pushColumns = args.pushColumns || false,
        columnOrder = args.columnOrder || [];

    $.each(options.searchOptions, function (searchOptionIndex, searchOption) {
        var theEntity = options.entity || "",
            searchBoxType = "TextBox",
            useAutocomplete = false,
            showSearchPopUp = options.showSearchPopUp || false,
            excludeList = [
                "QUOTENUMBER",
                "CALLERNAME",
                "SERIAL",
                "SERIALNUMBER",
                "EQUIPMENTNUMBER",
                "RENEWALNUMBER",
                "ORDERTEMPLATENUMBER",
                "INSPECTIONNUMBER",
                "INSPECTIONNAME",
                "VERSIONNUMBER",
                "TAXSCHEDULENAME",
                "CALLNUMBER",
                "ORDERNUMBER",
                "INVOICENUMBER",
                "ROLENAME",
                "EMPLOYEENUMBER",
                "USER",
                "CODENUMBER",
                "SERVICETECHNUMBER",
                "SERVICETECHNAME",
                "TAXSCHEDULENUMBER",
                "NAME",
                "PAYMENTNUMBER",
                "REFERENCENUMBER"
            ],
            entityExcludeList = [
                "USER",
                "SOURCEWAREHOUSE",
                "ADDRESSBOOK",
                "TIMEZONECOUNTRY",
                "TIMEZONEZONES",
                "REPORT"
            ],
            searchOptionLayout,
            searchOptionClasses = "search-input",
            searchOptionField = searchOption.field || searchOption,
            label = searchOptionField,
            htmlSearchOption = searchOptionField.replaceAll(".", "_"),
            searchBoxId = searchOption.id || `${_id}_${options.entityType}_${htmlSearchOption}`,
            iconId = `${searchBoxId}SearchIcon`,
            searchValue = searchOptionField,
            dataSource;

        if (options.searchType && options.searchType.screenEntityType) {
            label = `${options.searchType.screenEntityType}.${label}`;
        }

        // TODO: What is this used for
        if (searchOption.field == "Division" && options.divisionDefaultValue) {
            searchOption.defaultValue = options.divisionDefaultValue;
        }

        if (options.columnRenames) {
            var temp = options.columnRenames[searchOptionField];
            if (temp) {
                label = temp;
            }
        }

        // TODO: Not sure what this is for?
        if (pushColumns) {
            columnOrder.push(searchOption);
        }

        // Create Filter Hack that will search when user keypresses or hits enter
        var filter = function (e?) {
            if (options.liveFilter || (e && e.keyCode == 13)) {
                $(`#${_id}_filterDataButton`).click();
                var chart = $(`#${_id}`).data("kendoChart");
                if (chart && chart.element) {
                    chart.element.mask();
                }
            }
        };

        var debouncedFilter = _.debounce(function (e) {
            return filter(e);
        }, searchDebounceWait);

        if (searchOptionField.indexOf(".") != -1) {
            var splitArray = searchOptionField.split(".");
            searchValue = splitArray[splitArray.length - 1];
            theEntity = splitArray[splitArray.length - 2];
            // TODO: Look up the Entity using schema.json instead of this hack
            if (theEntity == "OwningCustomer") {
                theEntity = "Customer";
            } else if (theEntity == "ParentRegion") {
                theEntity = "Region";
            }
        }

        if (codes[searchValue]) {
            searchBoxType = "ComboBox";
            dataSource = codes[searchValue].slice(0);
        } else {
            if ((searchValue.toUpperCase().indexOf("NUMBER") != -1)
                || (searchValue.toUpperCase().indexOf("NAME") != -1)) {
                useAutocomplete = true;
            }

            if (excludeList.indexOf(searchValue.toUpperCase()) != -1
                || entityExcludeList.indexOf(theEntity.toUpperCase()) != -1) {
                useAutocomplete = false;
                showSearchPopUp = false;
            }
        }

        var componentOptions: any = {
            type: searchOption.type || searchBoxType,
            label: searchOption.label ||
                {
                    type: "ll",
                    value: label
                },
            entityType: searchOptionField,
            id: searchBoxId,
            inputBsc: "col-xs-7",
            field: searchOptionField,
            clearIfInvalid: false,
            classes: searchOptionClasses,
            dataSource: searchOption.dataSource || dataSource,
            bsc: " ",
            containerClasses: "search-field",
            systemCode: true,
            value: searchOption.defaultValue != null ? searchOption.defaultValue : "",
            iconType: (searchOption.showSearchPopUp || showSearchPopUp) ? "list" : "",
            iconId: (searchOption.showSearchPopUp || showSearchPopUp) ? iconId : "",
            iconClasses: (searchOption.showSearchPopUp || showSearchPopUp) ? "vam" : "",
        };

        var searchOptionZSelect = searchOption.zSelect;
        var schema = schemas[searchOption.searchType
            || (searchOption.searchTypes && searchOption.searchTypes[0].entityType)]
            || schemas[theEntity];

        if (useAutocomplete || searchOption.type == "AutoComplete") {
            componentOptions.type = "AutoComplete";
            componentOptions.searchType = componentOptions.searchType || theEntity;

            if (schema) {
                var displayFields = $.grep(Object.keys(schema.Properties), function (c) { return schema.Properties[c].Display; });

                componentOptions.dataTextField = _.find(displayFields, function (c) {
                    return schema.Properties[c] && schema.Properties[c].Display == "secondary";
                });

                componentOptions.bindNumberValue = _.find(displayFields, function (c) {
                    return schema.Properties[c] && schema.Properties[c].Display == "primary";
                });
            }
        }

        if (schema
            && schema.Properties
            && schema.Properties[componentOptions.field]
            && schema.Properties[componentOptions.field].Type == "Boolean") {// booleans not supported

            return;
        }

        if (componentOptions.type != "AutoComplete") {
            componentOptions.change = function (e) {
                if (options.liveFilter) {
                    $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.append(newLoadingMask({}));
                    $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.stop();
                    $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.scrollTop(0);
                    $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.css({"overflow-x": "hidden", "overflow-y": "hidden" });
                    debouncedFilter(e);
                }
            };
        }

        if ($.type(searchOption) == "object") {
            componentOptions = $.extend(componentOptions, searchOption);
        }

        componentOptions.zSelect = function (data) {
            var field = componentOptions.field.getStringAfterLastIndexOf("."),
                dataTextField = componentOptions.dataTextField,
                fieldData = data[field],
                textFieldData = data[dataTextField],
                numberFieldData = data[componentOptions.bindNumberValue];

            $(`#${componentOptions.id}`).val(textFieldData || fieldData);

            if (textFieldData) {
                $(`#${componentOptions.id}`)
                    .parents(".pane-field")
                    .find(".pane-field-number")
                    .text(numberFieldData);
            }

            $(`#${componentOptions.id}`).data("me").zData = data[field];

            if (options.liveFilter) {
                filter();
            }

            searchOptionZSelect && searchOptionZSelect.apply(this, [data, componentOptions]);
        };

        searchOptionLayout = buildView(componentOptions);
        searchOptionLayout.render(`#${_id}_SearchContainer`);

        if (searchOption.setAdditionalAutoCompleteFilter) {
            $(`#${componentOptions.id}`)
                .data("me")
                .setAdditionalFilter(searchOption.setAdditionalAutoCompleteFilter);
        }
        if (searchOption.defaultValue) {
            $(`#${componentOptions.id}`).data("me").zData = searchOption.defaultValue;
        }

        if (searchOption.defaultDisplayValue) {
            $(`#${componentOptions.id}`).val(searchOption.defaultDisplayValue);
        }

        switch (componentOptions.type) {
            case "ComboBox":
                $(`#${searchBoxId}`).data("default", searchOption.defaultValue);
                $(`#${searchBoxId}`).data("defaultDisplayValue", searchOption.defaultDisplayValue);
                $(`#${searchBoxId}`).data("kendoComboBox").trigger("zRefresh");
                break;
            case "AutoComplete":
                $(`#${searchBoxId}`).on("keyup", function () {
                    $(`#${searchBoxId}`).data("me").zData = null;
                });
            // tslint:disable-next-line:no-switch-case-fall-through
            default:
                $(`#${searchBoxId}`).on("keyup", function (e) {
                    if (options.liveFilter) {
                        $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.append(newLoadingMask({}));
                        $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.stop();
                        $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.scrollTop(0);
                        $(`#${_id}`).data("kendoGrid") && $(`#${_id}`).data("kendoGrid").content.css({"overflow-x": "hidden", "overflow-y": "hidden" });
                        debouncedFilter(e);
                        if (e && e.keyCode == 13) {
                            debouncedFilter.flush();
                        }
                    }
                });
                $(`#${searchBoxId}`).data("default", searchOption.defaultValue);
                $(`#${searchBoxId}`).data("defaultDisplayValue", searchOption.defaultDisplayValue);
        }
    });

    options.columnOrder = columnOrder;

    return options;
}

export function render(args) {
    var options = args.options,
        _id = args._id;

    var filterButton = new Button({
        id: `${_id}_filterDataButton`,
        classes: "filter-data-button",
        label: ll("Search", true)
    });

    var clearSearch = new Button({
        id: `${_id}_clearfiltersButton`,
        label: ll("Clear", true)
    });

    filterButton.render(`#${_id}_SearchContainer_Actions`);
    clearSearch.render(`#${_id}_SearchContainer_Actions`);
    if (options.clearAllFiltersOption) {
        var clearAllButton = new Button({
            id: `${_id}_clearAllButton`,
            label: ll("ClearAll")
        });
        clearAllButton.render(`#${_id}_SearchContainer_Actions`);
        $(`#${_id}_clearAllButton`).on("click", function () {
                clearFilters(false);
        });
    }

    if (options.liveFilter) {
        $(`#${_id}_filterDataButton`).hide();
        $(`#${_id}_SearchContainer`).css("min-height", 0);
    }

    if (options.hideSearchOptions) {
        $(`#${_id}_SearchContainer`).hide();
    }

    $(`#${_id}_filterDataButton`).on("click", function () {
        var chart = $(`#${_id}`).data("kendoChart"),
            searchDataSource;

        if (chart) {
            chart.element.mask();
            options.chart = chart;
            searchDataSource = chart.dataSource;
        }

        var grid = $(`#${_id}`).data("kendoGrid");
        if (grid) {
            searchDataSource = grid.dataSource;
        }

        var filters = options.filters || [];

        var searchInputs: any = $(`#${_id}_SearchContainer`)
            .find(".search-input:not(.js-ignore-from-search)");

        searchInputs = $.grep(searchInputs as any[], function (a) {
            return a.id != "" && a.id.indexOf("_CB_") == -1;
        });

        var allSpaces = true;

        if (options.filtered && options.widget && options.originalFilter) {
            options.filter = options.originalFilter;
        }

        $.each(searchInputs, function (searchInputIndex, searchInput) {
            var searchInputMe = $(searchInput).data("me"),
                value = $(searchInput).val();

            if ($(searchInput).data("ignore")) {
                return;
            }

            if ((value == null || value == "" || value == "None")
                && searchInputMe
                && searchInputMe.options
                && searchInputMe.options.entityType.getStringAfterLastIndexOf(".") != "Division") {
                return;
            }

            var valueField = $(searchInput).attr("name").replace(new RegExp("\\.", "g"), "/");

            if (chart) {
                if (valueField == "Region/RegionNumber") {
                    valueField = options.regionsNavigationTypes + valueField;
                }

                if (valueField == "Division") {
                    valueField = options.divisionsNavigationTypes + valueField;
                }
            }

            if ($(searchInput).attr("data-role")) {
                if ($(searchInput).attr("data-role").indexOf("combobox") != -1) {
                    var kcb = $(searchInput).data("kendoComboBox") as any;
                    kcb.trigger("zRefresh");

                    if ((!kcb.dataItem() || !kcb.dataItem().odata)
                        && (kcb.selectedIndex == "-1" || value == "-1")) {
                        if ($(searchInput).data("default")) {
                            var indexValue = $(searchInput).data("default");
                            kcb.value(indexValue);
                        } else {
                            kcb.value("");
                            return;
                        }
                    }

                    if (kcb.dataItem() && kcb.dataItem().odata) {
                        let odata = kcb.dataItem().odata;
                        if (odata) {
                            allSpaces = false;
                            filters.push(odata);
                        }

                        return;
                    }

                    var comboBoxFilter = {
                        field: `${valueField}Id`,
                        operator: "eq",
                        value: value
                    };

                    allSpaces = false;
                    filters.push(comboBoxFilter);
                    return;
                } else if ($(searchInput).attr("data-role").indexOf("autocomplete") != -1) {
                    if ($(searchInput).data("me").zData) {
                        var autocompleteFilter = {
                            field: valueField,
                            operator: "eq",
                            value: $(searchInput).data("me").zData
                        };

                        allSpaces = false;
                        filters.push(autocompleteFilter);
                        return;
                    }
                } else if ($(searchInput).attr("data-role").indexOf("dropdownlist") != -1) {
                    if ($(searchInput).data("kendoDropDownList").dataItem()) {
                        let odata = $(searchInput).data("kendoDropDownList").dataItem().odata;
                        if (odata) {
                            allSpaces = false;
                            filters.push(odata);
                        }

                        return;
                    }
                }
            }

            // Check for a date field type, if found, convert the value to ANSI DATE format for comparison
            if (valueField.toUpperCase().indexOf("DATE") != -1) {
                var kendoDatePicker = $(searchInput).data("kendoDatePicker");
                var kendoDateTimePicker = $(searchInput).data("kendoDateTimePicker");
                var datePicker = kendoDatePicker || kendoDateTimePicker;

                if (datePicker) {
                    value = datePicker.value().toISOString().substr(0, 10);
                }
            }

            if (value != "-1") {
                var newFilter = {
                    field: valueField,
                    operator: "startswith",
                    value: value
                };

                if (newFilter.value.replace(/\s/g, "").length) {
                    allSpaces = false;

                    if (filters == null) {
                        if (newFilter.value) {
                            filters = [newFilter];
                        }
                    } else {
                        var isNew = true;
                        var filterIndex;

                        for (filterIndex = 0; filterIndex < filters.length; filterIndex++) {
                            if (filters[filterIndex].field == newFilter.field) {
                                isNew = false;
                                break;
                            }
                        }

                        if (isNew && newFilter.value) {
                            filters.push(newFilter);
                        } else if (newFilter.value == "") {
                            filters.splice(filterIndex, 1);
                        } else {
                            filters[filterIndex] = newFilter;
                        }
                    }
                }
            }
        });

        // Append the regions filter seperate from the search options so its always there and is not cleared when user hits clear button
        var regionFilterOptions = divisionRegion.getRegionSearchOptionFilter(options);

        if (regionFilterOptions && regionFilterOptions.regionFilter && !regionFilterOptions.allSpaces) {
            filters.push(regionFilterOptions.regionFilter);
        }

        if (filters && filters.length > 0) {
            searchDataSource.filter(filters);
        } else {
            searchDataSource.filter({});
        }

        if (chart) {
            options.dataSource = searchDataSource;

            var getDataSourceFilters = buildODataKendoParams({
                data: {
                    filter: {
                        logic: "and",
                        filters: filters
                    }
                }
            });

            let filter = options.originalFilter;

            if (filter && getDataSourceFilters.$filter) {
                filter += ` AND ${getDataSourceFilters.$filter}`;
            } else if (getDataSourceFilters.$filter) {
                filter = getDataSourceFilters.$filter;
            }

            options.filter = filter || "";
            options.filtered = true;
            charts.handleRequestsForPieChart(options);
        }
    });

    $(`#${_id}_clearfiltersButton`).on("click", function () {
        clearFilters(true);
    });

    var clearFilters = function ( useDefaults: boolean = true) {

        var chart = $(`#${_id}`).data("kendoChart");
        if (chart) {
            chart.element.mask();
        }

        var searchInputs: any = $(`#${_id}_SearchContainer`).find(".search-input");
        searchInputs = $.grep(searchInputs as any[], function (a) {
            return a.id != "" && a.id.indexOf("_CB_") == -1;
        });

        $.each(searchInputs, function (searchInputIndex, searchInput) {
            var element: any = $(`#${searchInput.id}`);

            if (element.val != "") {
                var data = $(`#${searchInput.id}`).data();
                var kendoControl = "";

                if (data.ignore) {
                    return;
                }

                for (var k in data) {
                    if (k.indexOf("kendo") != -1) {
                        kendoControl = k;
                        break;
                    }
                }

                if (kendoControl) {
                    if (data.default != null && useDefaults) {
                        $(`#${searchInput.id}`).data(kendoControl).value(data.default);
                        $(`#${searchInput.id}`).val(data.defaultDisplayValue || data.default);
                    } else {
                        $(`#${searchInput.id}`).data(kendoControl).value(null);
                        $(`#${searchInput.id}`)
                            .parents(".pane-field")
                            .find(".pane-field-number")
                            .text("");
                    }
                } else {
                    if (data.default != null && useDefaults) {
                        $(`#${searchInput.id}`).val(data.default);
                    } else {
                        $(`#${searchInput.id}`).val("");
                    }
                }

                $(`#${searchInput.id}`).data("me").zData = data.default;
            }
        });

        $(`#${_id}_filterDataButton`).click();
    };
}

var ui = {};
export function registerComponents(components) {
    _.extend(ui, components);
}

// Pain points for removing this last remaining call to buildView:
// Search options on My Orders, My Quotes, and My Calls
// Search options for Divisions and Regions
// Search options specified in database in Widget definitions
function buildView(view, me?) {
    var base;
    me = me || {};
    if (view) {
        if (!view.type) {
            return;
        }
        view.zScreen = me;
        base = buildControl(view);

    } else {
        alert({ message: "Made call to z.buildView, but the view is undefined." });
        throw new Error("Made call to buildView, but view is undefined.");
    }

    return base;
}

function buildControl(component) {
    var control = clone(component);
    var crx;

    if (control.type != null) {
        try {
            crx = new ui[control.type](control);

            _.forEach(crx.content, (components, property) => {
                _.forEach(components, (child, index) => {
                    crx.content[index] = buildControl(child);
                });
            });
        } catch (e) {
            alert({
                type: "danger",
                message: `Unknown component - ${control.type} - in view structure.`,
                fade: !settings.showDebugMessages
            });

            if (settings.showDebugMessages && e && (e.message || typeof e == "string")) {
                var message = e.message || e;
                if (message != "ns[control.type] is not a function") {
                    alert({ type: "danger", message: message, fade: false });
                }
            }
            return;
        }

        return crx;
    }
}
